module.exports = __webpack_public_path__ + "static/media/iphone_screen3.c934ddc9.png";